<!--
   Copyright (C) GridGain Systems. All Rights Reserved.
   _________        _____ __________________        _____
   __  ____/___________(_)______  /__  ____/______ ____(_)_______
   _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
   / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
   \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
-->

@if (data.title) {
  <h1 mat-dialog-title gta="confirm-dialog__title">{{ data.title }}</h1>
}
<p mat-dialog-content [style.whiteSpace]="'pre-line'" gta="confirm-dialog__message">{{ data.message }}</p>
<div mat-dialog-actions>
  <button
    type="button"
    mat-button
    [mat-dialog-close]="false"
    gta="confirm-dialog__button-dismiss"
    angulartics2On="click"
    angularticsCategory="DialogDismiss"
    angularticsAction="ConfirmationDialog"
    [angularticsLabel]="data.title ?? ''"
    >{{ data.dismissButtonLabel }}</button
  >
  <button
    type="button"
    mat-button
    [mat-dialog-close]="true"
    gta="confirm-dialog__button-confirm"
    angulartics2On="click"
    angularticsCategory="ButtonClick"
    angularticsAction="ConfirmationDialog_Confirm"
    [angularticsLabel]="data.title ?? ''"
    >{{ data.confirmButtonLabel }}</button
  >
</div>
